import { useEffect, useState } from 'react';

interface CountdownProps {
  startDate: string; // expects ISO 8601 (with Z if UTC)
  venue?: string;
}

export const Countdown = (props: CountdownProps): React.JSX.Element => {
  const target = new Date(props.startDate); // parses as UTC if 'Z' is included

  const getTimeLeft = () => {
    const now = new Date();
    const diff = target.getTime() - now.getTime();
    return diff > 0 ? diff : 0;
  };

  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(interval);
  }, [props.startDate]);

  const totalSeconds = Math.floor(timeLeft / 1000);
  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const out: string[] = [];
  const addUnit = (num: number, label: string) => {
    if (num > 0) {
      out.push(num + ' ' + label + (num > 1 ? 's' : ''));
    }
  };
  addUnit(days, 'day');
  addUnit(hours, 'hour');
  addUnit(minutes, 'minute');
  if (out.length === 0) {
    out.push('less than a minute');
  }
  return (
    <div>
      Starts in {out.join(', ')}
      {props.venue && (
        <div className="mb-2">
          <a
            href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(props.venue)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Get directions
          </a>
        </div>
      )}
    </div>
  );
};
